var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Grid, Typography, useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { t } from "i18next";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { MuiIconButton, MuiRightDrawer } from "../../../builderPackage/components";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { MuiBox } from "../../../components";
import { setReducerState, setState } from "../../../redux/crudSlice";
import { useAppSelector } from "../../../store/hooks";
import { systemColor } from "../../../theme/systemColor";
// import { CrossIcon } from "../../spareIssue/assets";
import { proxyListAPICall } from "../../spareParts/purchaseRequistion/services/apiCall";
import { PurchaseRequisitionKeys } from "../../spareParts/purchaseRequistion/services/entity";
import { priorityPickListApiCall, purchaseOrderListGet, statusListPOGet } from "../services/apiCalls";
import { PurchaseOrderKeys } from "../services/entity";
import { CrossIcon } from "../../../assets/images";
export var FilterPurchaseOrder = function (props) {
    var isFilterOpen = props.isFilterOpen, setFilterOpen = props.setFilterOpen;
    var _a = useState(), dateRange = _a[0], setDateRange = _a[1];
    var _b = useState(), fromDate = _b[0], setFromDate = _b[1];
    var _c = useState(), ToDate = _c[0], setToDate = _c[1];
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var dispatch = useDispatch();
    var filterValue = crud['filterValue'];
    var handleApplyClick = function (event, values) {
        var _values$FromDate, _values$ToDate;
        var req = {
            DateRange: values === null || values === void 0 ? void 0 : values.DateRange,
            Status: values === null || values === void 0 ? void 0 : values.Status,
            Type: values === null || values === void 0 ? void 0 : values.Type,
            Priority: values === null || values === void 0 ? void 0 : values.Priority,
            FromDate: fromDate ? fromDate : (_values$FromDate = values === null || values === void 0 ? void 0 : values.FromDate) !== null && _values$FromDate !== void 0 ? _values$FromDate : "",
            ToDate: ToDate ? ToDate : (_values$ToDate = values === null || values === void 0 ? void 0 : values.ToDate) !== null && _values$ToDate !== void 0 ? _values$ToDate : ""
        };
        dispatch(setState({
            key: "filterValue",
            value: {
                data: req,
                success: true
            }
        }));
        dispatch(setReducerState({
            key: PurchaseOrderKeys.Paging + 'Updated',
            value: true
        }));
        setFilterOpen(false);
    };
    var handleRangeChange = function (range) {
        var currentDate = new Date();
        switch (range) {
            case 'Weekly':
                var nextWeekDate = new Date(currentDate.getTime() + 7 * 24 * 60 * 60 * 1000);
                setFromDate(currentDate);
                setToDate(nextWeekDate);
                return nextWeekDate;
            case 'Monthly':
                var nextMonthDate = new Date(currentDate.getTime() + 30 * 24 * 60 * 60 * 1000);
                setFromDate(currentDate);
                setToDate(nextMonthDate);
                return nextMonthDate;
            case 'Yearly':
                var nextYearDate = new Date(currentDate.getTime() + 365 * 24 * 60 * 60 * 1000);
                setFromDate(currentDate);
                setToDate(nextYearDate);
                return nextYearDate;
            case 'Custom':
                return 'Custom';
            default:
                return null;
        }
    };
    var formData = [{
            type: FormItemTypes.Custom,
            name: 'Header',
            label: '',
            element: function () { /*#__PURE__*/ return React.createElement(MuiBox, null, /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                spacing: 5,
                paddingTop: IS_DESKTOP ? 8 : 0,
                paddingBottom: 2
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 10
            }, /*#__PURE__*/ React.createElement(Typography, {
                style: {
                    fontSize: '16px',
                    fontWeight: '600'
                },
                color: "black"
            }, t("Filters"))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 2
            }, /*#__PURE__*/ React.createElement(MuiIconButton, {
                onClick: function () { return setFilterOpen(false); },
                style: {
                    justifyContent: 'flex-end'
                },
                id: "cancelButton"
            }, /*#__PURE__*/ React.createElement("img", {
                id: "crossIconBtn",
                src: CrossIcon
            }))))); },
            value: null,
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'FormContainer',
            label: '',
            value: null,
            columnSize: 12,
            sx: {
                marginBottom: '15px',
                flexGrow: 1,
                overflowY: 'auto',
                padding: '16px'
            },
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'FilterName',
                    label: '',
                    displayExpr: "Name",
                    placeholder: "Select saved filter",
                    valueExpr: "id",
                    apiKey: PurchaseRequisitionKeys.ProxyList,
                    getListData: proxyListAPICall,
                    // startAdornment: <img src={FilterLineIcon} style={{ margin: 3 }} />, prop removed to fix multiselect issue
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Type',
                    multiple: true,
                    label: 'PO type',
                    displayExpr: "Name",
                    getListData: purchaseOrderListGet,
                    labelTypographyProps: {
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#8593A3"
                    },
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'DateRange',
                    label: 'Date range',
                    labelTypographyProps: {
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#8593A3"
                    },
                    options: [{
                            id: 1,
                            name: 'Weekly'
                        }, {
                            id: 2,
                            name: 'Monthly'
                        }, {
                            id: 3,
                            name: 'Yearly'
                        }, {
                            id: 4,
                            name: 'Custom'
                        }],
                    onChange: function (event, value) {
                        setDateRange(value === null || value === void 0 ? void 0 : value.name);
                        handleRangeChange(value === null || value === void 0 ? void 0 : value.name);
                    },
                    valueExpr: "id",
                    displayExpr: 'name',
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'date',
                    label: '',
                    value: null,
                    elements: __spreadArray([], (dateRange == 'Custom' ? [{
                            type: FormItemTypes.Typography,
                            name: 'date',
                            label: 'Date',
                            labelTypographyProps: {
                                fontSize: "12px",
                                fontWeight: "500",
                                color: "#8593A3",
                                padding: 0,
                                margin: 0
                            },
                            value: null,
                            columnSize: 12
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'FromDate',
                            label: '',
                            placeholder: "From",
                            value: null,
                            setFormState: function () { return ({
                                ToDate: null
                            }); },
                            columnSize: 6
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'ToDate',
                            label: '',
                            placeholder: "To",
                            value: null,
                            setFieldProps: function (formValues) {
                                return {
                                    minDate: dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.FromDate)
                                };
                            },
                            columnSize: 6
                        }] : []), true),
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Status',
                    label: 'Status',
                    multiple: true,
                    getListData: statusListPOGet,
                    apiKey: PurchaseOrderKeys.Status,
                    labelTypographyProps: {
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#8593A3"
                    },
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Priority',
                    getListData: priorityPickListApiCall,
                    multiple: true,
                    label: 'Priority',
                    labelTypographyProps: {
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#8593A3"
                    },
                    valueExpr: "id",
                    value: null,
                    columnSize: 12,
                    sx: {
                        marginBottom: '50px'
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            label: '',
            value: null,
            spacing: 0,
            sx: {
                bottom: 0,
                justifyContent: 'space-between',
                backgroundColor: 'white',
                width: {
                    xs: '100%',
                    sm: '400px'
                },
                position: 'fixed',
                right: 0,
                zIndex: 1000,
                paddingBottom: '16px',
                borderTop: "1px solid #DEE4EB"
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Save Filter',
                    label: '',
                    children: 'Save Filter',
                    value: null,
                    xs: 4,
                    sm: 4,
                    md: 4,
                    lg: 4
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'saveButton',
                    label: '',
                    value: null,
                    xs: 8,
                    sm: 8,
                    md: 8,
                    lg: 8,
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'discard',
                            label: '',
                            children: 'Reset Filters',
                            onClick: function () {
                                return 'reset';
                            },
                            value: null,
                            id: "discard",
                            xs: 7,
                            sm: 7,
                            md: 7,
                            lg: 7,
                            sx: {
                                border: '1px solid #DEE4EB',
                                marginLeft: '2px'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Apply',
                            label: '',
                            children: 'Apply',
                            value: null,
                            xs: 2,
                            sm: 2,
                            md: 2,
                            lg: 2,
                            onClick: handleApplyClick,
                            sx: {
                                border: '1px solid #DEE4EB',
                                backgroundColor: systemColor.primary,
                                color: '#FFFFFF',
                                ":hover": {
                                    color: systemColor.primary
                                }
                            }
                        }]
                }],
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(MuiRightDrawer, {
        id: "filter-drawer",
        anchor: "right",
        openDrawer: isFilterOpen,
        onClose: function () { return setFilterOpen(false); },
        sx: {
            width: {
                xs: '100%',
                sm: "400px"
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        formProps: {
            p: 1.5
        },
        getKey: "filterValue",
        mode: "edit"
    }));
};
